import React from 'react';
const tomes = [{
  number: '01',
  title: 'Morfofisiología Extrema',
  desc: 'Osteología, artrología, miología, sistema nervioso, cardiovascular y fisiología del ejercicio.'
}, {
  number: '02',
  title: 'Biomecánica y Evaluación Kinésica',
  desc: 'Cinemática, cinética, evaluación postural, marcha y razonamiento clínico biomecánico.'
}, {
  number: '03',
  title: 'Agentes Físicos y Tecnología Kinésica',
  desc: 'Termoterapia, crioterapia, electroterapia, ultrasonido, láser y tracción.'
}, {
  number: '04',
  title: 'Clínica Kinésica Superior',
  desc: 'Traumatología, neurología, cardiorrespiratoria y reumatología con casos resueltos.'
}, {
  number: '05',
  title: 'Técnicas Manuales y Ejercicio Terapéutico',
  desc: 'Masoterapia, movilización articular, stretching, Pilates y ejercicio terapéutico.'
}, {
  number: '06',
  title: 'Supervivencia Hospitalaria y Práctica Pre-Profesional',
  desc: 'Signos vitales, UTI, higiene bronquial, documentación clínica y salida laboral.'
}];
const includes = ['Protocolos y parámetros clínicos listos para exámenes', 'Casos clínicos resueltos paso a paso por región', 'Checklists de evaluación kinésica por área', 'Resúmenes, mnemotecnias y autoevaluación por unidad'];
export function WhatYouGet() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-8 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(219,234,254) 0%, rgb(239,246,255) 50%, rgb(255,255,255) 100%)'
  }} data-id="element-355">
      <div className="mx-auto max-w-4xl" data-id="element-356">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-1" data-id="element-357">
          Lo que <span className="text-blue-700" data-id="element-358">recibís</span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-6" data-id="element-359">
          6 tomos · +360 páginas · Toda la carrera organizada
        </p>

        {/* Tomos */}
        <div className="bg-white border border-blue-700/20 rounded-xl overflow-hidden shadow-sm mb-4" data-id="element-360">
          {/* Header */}
          <div className="bg-blue-700 px-5 py-2.5" data-id="element-361">
            <h3 className="text-sm font-black text-white m-0 tracking-wide" data-id="element-362">
              📚 LOS 6 TOMOS — Toda la carrera en un solo lugar
            </h3>
          </div>

          {/* Tomes list */}
          <div className="divide-y divide-gray-100" data-id="element-363">
            {tomes.map(tome => <div key={tome.number} className="flex items-center gap-4 px-5 py-2.5" data-id="element-364">
                <span className="shrink-0 text-lg font-black text-blue-700/30 w-8 text-center" data-id="element-365">
                  {tome.number}
                </span>
                <div className="flex-1 min-w-0" data-id="element-366">
                  <span className="block text-sm font-black text-gray-900" data-id="element-367">
                    {tome.title}
                  </span>
                  <span className="block text-xs text-gray-500 mt-0.5" data-id="element-368">
                    {tome.desc}
                  </span>
                </div>
                <span className="shrink-0 text-[10px] font-bold text-blue-700 bg-blue-700/5 border border-blue-700/20 rounded-full px-2 py-0.5" data-id="element-369">
                  60 pág.
                </span>
              </div>)}
          </div>
        </div>

        {/* Cada tomo incluye */}
        <div className="grid grid-cols-2 gap-2" data-id="element-370">
          {includes.map(item => <div key={item} className="flex items-start gap-2 bg-white border border-blue-700/20 rounded-lg px-4 py-2.5" data-id="element-371">
              <span className="shrink-0 text-blue-700 font-bold text-sm" data-id="element-372">
                ✅
              </span>
              <span className="text-xs text-gray-700 leading-5" data-id="element-373">{item}</span>
            </div>)}
        </div>
      </div>
    </section>;
}